export const scrollOptions = {
  padding: 15,
  duration: 500
};
